module.exports = __webpack_public_path__ + "media/good.7102264c.mp3";